export default __webpack_public_path__ + "static/media/Certilytics-Logo-Icons-10.88e7310e.svg";